@if (!isEmbeddedView) {
<div class="header">
  <div class="home">
    <div class="title">
      {{ (headerData$ | async)?.title }}
    </div>
  </div>
  <div class="name">
    <span>Welcome</span>
    <span>{{ name }}</span>
  </div>
  <div>
    <span class="super-user">{{
      profileData.adminRoles?.includes('jiox-admin')
        ? 'Super Admin'
        : profileData.adminRoles && profileData.adminRoles[0]
    }}</span>
  </div>
  <div class="admin-photo" (click)="viewProfile()">
    <img
      class="cursor-pointer"
      src="assets/images/common/user_profile.jpg"
      alt="photo"
    />
  </div>
</div>
} @if (getNumber((headerData$ | async)?.breadcrumbs) > 1 && !isEmbeddedView) {
<nav class="breadcrumb-container" aria-label="Breadcrumb">
  @for ( breadcrumb of (headerData$ | async)?.breadcrumbs; track breadcrumb.url
  ) { @if (!$first) {
  <span class="breadcrumb-separator" aria-hidden="true">&gt;</span>
  }
  <span
    (click)="!$last && navigate(breadcrumb.url)"
    class="breadcrumb"
    [class.breadcrumb--current]="$last"
    [class.breadcrumb--link]="!$last"
  >
    {{ breadcrumb.label }}
  </span>
  }
</nav>
}
